module.exports = __webpack_public_path__ + "static/offer-pen-6ac9a9e02e41ccd12f9a20b65bf13b26.png";